import { createReducer, on } from '@ngrx/store';
import { UsersActions } from '../_actions/users.actions';
import { UserModel } from '../../_models/user.model';
import { RoleModel } from '../../_models/role.model';

export interface UsersState {
  list: {
    filters: any;
    data: ReadonlyArray<UserModel>;
    total: number;
  };
  selected: UserModel | null;
  roles: RoleModel[];
  points: {
    points_earned: number;
    points_used: number;
    points_available: number;
    loading: boolean;
  };
}

export const initialStateUser: UsersState = {
  list: {
    filters: {},
    data: [],
    total: 0,
  },
  selected: null,
  roles: [],
  points: {
    points_earned: 0,
    points_used: 0,
    points_available: 0,
    loading: false,
  },
};

export const usersFeatureKey = 'users';

export const usersReducer = createReducer(
  initialStateUser,
  on(UsersActions.loadUsers, (state, { filters }) => ({
    ...state,
    list: {
      ...state.list,
      filters,
    },
  })),
  on(UsersActions.loadUsersSuccess, (state, { items, total }) => ({
    ...state,
    list: {
      ...state.list,
      data: items,
      total: total,
    },
  })),
  on(UsersActions.loadUserSuccess, (state, { data }) => ({
    ...state,
    selected: data,
  })),
  on(UsersActions.loadUserRolesSuccess, (state, { items }) => ({
    ...state,
    roles: items.map((item) => new RoleModel(item)),
  })),
  on(UsersActions.loadPoints, (state) => ({
    ...state,
    points: {
      ...state.points,
      loading: true,
    },
  })),
  on(UsersActions.loadPointsSuccess, (state, { points_earned, points_used, points_available }) => ({
    ...state,
    points: {
      points_earned,
      points_used,
      points_available,
      loading: false,
    },
  })),
  on(UsersActions.loadPointsFailure, (state) => ({
    ...state,
    points: {
      ...state.points,
      loading: false,
    },
  }))
);
